import React, { Component } from 'react';
import classNames from 'classnames';

import { Video } from './Video';
import UniversalLinkContainer from './UniversalLink';

export default class HeroGeneral extends Component {
  constructor(props) {
    super(props);

    this.state = {
      textColor: this.props.textColor || this.props.image ? 'white' : 'charcoal',
      image: this.props.image,
      header: this.props.header,
    };
  }

  static createMarkup(content) {
    return { __html: content };
  }

  render() {
    // FIXME: CMS replace lookup and createMarkup
    const {
      anchor,
      links,
    } = this.props;
    const email = 'support@burrow.com';
    const link = links && !!links.length ? links[0] : null;
    let { subHeader } = this.props;

    // TODO: [GRAPHCMS] need to deprecate the email prop on components
    if (
      subHeader
      && ~subHeader.indexOf('{contact}')
    ) {
      subHeader = subHeader.replace(/\{contact\}/g, `<a target="blank" href="mailto:${email}">contact us</a>`);
    }
    return (
      <div
        id={anchor || undefined}
        className={`hero-general${this.props.videoUrl ? ' hero-general-video' : ''}${this.props.image ? ` images ${this.state.image}` : ''} ${this.state.textColor ? this.state.textColor : ''}`}
      >
        {this.props.videoUrl && (
          <Video
            className="hero-general-video-container"
            src={this.props.videoUrl}
          />
        )}
        <div className="hero-general-headers">
          {this.props.header && (
            <h2 className={
              classNames('h1', {
                shadow: this.props.shadow,
              })}
            >
              {this.props.header}
            </h2>
          )}
          {subHeader && (
            <p className="hero-general-headers__subheader" dangerouslySetInnerHTML={HeroGeneral.createMarkup(subHeader)}/>
          )}
          {this.props.copy && (
            <p className="hero-general-headers__copy">{this.props.copy}</p>
          )}
          {link && (
            <UniversalLinkContainer
              to={link.destinationPage.url}
              type={link.type}
              className={link.className || 'button btn-terracotta'}
              target="_blank"
              location="hero"
            >
              {link.text}
            </UniversalLinkContainer>
          )}
        </div>
      </div>
    );
  }
}
